import React from "react";
import SEO from "./SEO";
import "./Store.css";

const STORE_BOOKS = [
  {
    title: "The Godly Husband: Biblical Leadership, Sacrificial Love, and Leaving a Lasting Legacy",
    author: "Christopher Kaspar",
    link: "https://a.co/d/jjLFphr",
    videoId: "rvrqwc-Stp8",
    cover: "https://m.media-amazon.com/images/I/41zF47wyL+L._AC_.jpg",
    description:
      "Practical teaching on leading your family with Jesus-centered humility, shepherding your home, and stewarding a legacy of faith.",
  },
  {
    title: "Become Zero: The Way to True Greatness in God’s Kingdom: Embracing Humility, Surrender, and the Life of Jesus",
    author: "Christopher Kaspar",
    link: "https://a.co/d/8deJWOg",
    videoId: "4vp7kaZ9YFQ",
    cover: "https://m.media-amazon.com/images/I/41TuAa5NS8L._AC_.jpg",
    description:
      "A call to abandon ambition for servanthood, embracing a Christ-like posture that values humility, surrender, and kingdom obedience.",
  },
];

const MEMBERSHIP_TIERS = [
  {
    name: "Bronze",
    price: "US$0.99",
    perks: [
      "Loyalty badges",
      "Custom emoji",
      "Early access to new videos",
      "Members-only chat rooms",
      "Access to the Bible module.",
    ],
  },
  {
    name: "Silver",
    price: "US$2.99",
    perks: [
      "Member shout-outs",
      "Members-only videos",
      "Perks from previous levels.",
      "Access to author songs via a custom catalog.",
      "Personalized worship models, ideal for worship leaders.",
    ],
  },
  {
    name: "Gold",
    price: "US$4.99",
    perks: [
      "Access to Worship Tools",
      "Perks from previous levels.",
      "Access to the session page for full session development.",
      "Support to update the site based on your needs.",
    ],
  },
];

const CHANNEL_ID = "UCdtaCSCH4gtibrDZ_Biwqxw";

export default function Store() {
  return (
    <div className="store-page">
      <SEO
        title="Store"
        description="Support the ministry with memberships and recommended resources."
      />
      <section className="membership-section">
        <div className="membership-header">
          <p className="store-kicker">Channel Support</p>
          <h2>Subscribe &amp; become a member of @gcc-worship</h2>
        </div>
        <div className="membership-actions">
          <a
            href={`https://www.youtube.com/channel/${CHANNEL_ID}?sub_confirmation=1`}
            target="_blank"
            rel="noopener noreferrer"
            className="membership-link"
          >
            Subscribe for free
          </a>
          <a
            href={`https://www.youtube.com/channel/${CHANNEL_ID}/join`}
            target="_blank"
            rel="noopener noreferrer"
            className="membership-link"
          >
            Join the membership
          </a>
        </div>
        <div className="membership-grid">
          {MEMBERSHIP_TIERS.map((tier) => (
            <article className="membership-card" key={tier.name}>
              <header>
                <p className="membership-tier">{tier.name}</p>
                <p className="membership-price">{tier.price}</p>
              </header>
              <ul>
                {tier.perks.map((perk) => (
                  <li key={perk}>{perk}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section className="store-grid">
        {STORE_BOOKS.map((book) => (
          <article className="store-card" key={book.title}>
            <div className="store-card-cover">
              <img src={book.cover} alt={`${book.title} cover`} loading="lazy" />
            </div>
            <div className="store-card-body">
              <h2>{book.title}</h2>
              <p className="store-author">by {book.author}</p>
              <p className="store-description">{book.description}</p>
              <div className="store-actions">
                <a
                  href={book.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="store-link"
                >
                  View on Amazon
                </a>
              </div>
            </div>
            <div className="store-card-video">
              <iframe
                src={`https://www.youtube.com/embed/${book.videoId}?autoplay=1&mute=1&playsinline=1&loop=1&playlist=${book.videoId}`}
                title={`${book.title} video`}
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
